import React, { Component } from 'react';
import { connect } from 'react-redux';
import { contentChange } from '../actions/content';
import ReactTimeout from 'react-timeout';
import SimpleButton from '../components/atoms/SimpleButton';


class NextStep extends Component {
  constructor(props) {
    super(props);
    this.changeContent = this.changeContent.bind(this);
    this.hideSubmitting = this.hideSubmitting.bind(this);
    this.state = {submitting:false, isActive: false};
  }
  componentDidUpdate(prevProps, prevState) {
    const allowedWatcher = ["options","bundle"];
    if(this.props.next.watch!=='' && allowedWatcher.includes(this.props.next.watch) && this.props.status[this.props.next.watch].isset && !this.state.submitting && !prevState.isActive) {
      this.setState({...this.state, isActive:true});
    }
  }

  clickNext() {
    if(this.props.next.watch==='' || !this.props.status[this.props.next.watch].isset || this.state.submitting) {
      return;
    }
    this.setState({submitting:true});
    if(this.props.next.submitDelay>0) {
      this.props.setTimeout(this.changeContent,this.props.next.submitDelay);
    } else {
      this.changeContent();
    }
  }

  changeContent() {
    this.props.dispatch(contentChange(this.props.next.link));
    this.props.setTimeout(this.hideSubmitting,300);
  }

  hideSubmitting() {
    this.setState({submitting:false, isActive:false});
  }


  render() {

    return (
        <div id="nextstep" className={this.state.isActive || (this.props.next.watch!=='' && this.props.status[this.props.next.watch].isset)?"active":!this.props.next.isActive?"hidden":""}>
          <div className={`btn${!this.props.next.isActive?" hidden":""}${this.state.submitting?" submitting":""}`}>
            <SimpleButton onClick={() => this.clickNext()}>{this.props.next.label} <span className="def">»</span><span className="ani">»</span><span className="submitting"><div className="mnml-spinner"></div></span></SimpleButton>
            
            {
              this.props.next.addText!=='' && <div className="addtext">{this.props.next.addText}</div>
            }
            
          </div>
        </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    status: state.status,
    next: state.next
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(NextStep))


// WEBPACK FOOTER //
// ./src/utils/NextStep.js